import Cookies from 'js-cookie'

const JSON_HEADER = { 'Accept': 'application/json', 'Content-Type': 'application/json' }

const buildJsonHeader = (m, b) => ({
  method: m,
  headers: JSON_HEADER,
  body: JSON.stringify(b),
  credentials: 'same-origin'
})

export const RESPONSE_TYPE = {
  JSON: 'json',
  TEXT: 'text',
  NONE: 'none',
  RESPONSE: 'response',
}

const isErrorKst = payload => payload.__errorKst

const handleFetchErrors = res => {
  return new Promise((resolve, reject) => {
    if (res.ok) { return resolve(res) }

    res.json()
      .then(j => {
        console.log(j)        
        isErrorKst(j) ? reject(j) : reject({...res, data: j})
      })
      .catch(_ => reject(res))
  })
}

const fetchFlow = (fetchCall, dispatch, onSucces, onFailure, respType = RESPONSE_TYPE.JSON) => {
  return new Promise((resolve, reject) => {
    fetchCall()
      .then(handleFetchErrors)
      .then(res => {
        if (res.status === 204 && respType !== RESPONSE_TYPE.NONE) {
          console.warn('Trying to get data from a 204 Response!')
          return undefined
        }

        switch (respType) {
          case RESPONSE_TYPE.JSON: return res.json()
          case RESPONSE_TYPE.TEXT: return res.text()
          case RESPONSE_TYPE.NONE: return undefined
          default: return res
        }
      })
      .then(result => {
        dispatch(onSucces(result))
        resolve(result)
      })
      .catch(err => {
        // If the error status is 401, it will redirect the user to login, as the session is expired.
        // Removing cookie.
        if(err.status === 401) {
          Cookies.remove('manager_tok');

          return window.location.href = '/login';
        }

        dispatch(onFailure(err))
        reject(err)
      })
  })
}

const dispatchFetch = (fetchCall, onBegin, onSucces, onFailure, respType = RESPONSE_TYPE.JSON) => {
  return dispatch => {
    dispatch(onBegin())
    return fetchFlow(fetchCall, dispatch, onSucces, onFailure, respType)
  }
}

export const dispatchFetchGet = (url, onBegin, onSucces, onFailure, respType = RESPONSE_TYPE.JSON) => {
  const fCall = () => fetch(url, { method: 'GET', credentials: 'same-origin' })
  return dispatchFetch(fCall, onBegin, onSucces, onFailure, respType)
}

export const dispatchFetchPost = (url, body, onBegin, onSucces, onFailure, respType = RESPONSE_TYPE.JSON) => {
  const fCall = () => fetch(url, buildJsonHeader('POST', body || {}))
  return dispatchFetch(fCall, onBegin, onSucces, onFailure, respType)
}

export const dispatchFetchPut = (url, body, onBegin, onSucces, onFailure, respType = RESPONSE_TYPE.JSON) => {
  const fCall = () => fetch(url, buildJsonHeader('PUT', body || {}))
  return dispatchFetch(fCall, onBegin, onSucces, onFailure, respType)
}

export const dispatchFetchDelete = (url, onBegin, onSucces, onFailure, respType = RESPONSE_TYPE.JSON) => {
  const fCall = () => fetch(url, { method: 'DELETE', credentials: 'same-origin' })
  return dispatchFetch(fCall, onBegin, onSucces, onFailure, respType)
}

export const dispatchCustomFetch = (fetchCall, onBegin, onSucces, onFailure, respType = RESPONSE_TYPE.JSON) => {
  return dispatchFetch(fetchCall, onBegin, onSucces, onFailure, respType)
}